<template>
  <div class="auth-page">
    <button
      type="button"
      class="welcome-back-btn"
      aria-label="Back to welcome"
      @click="
        $playSound();
        $router.push('/welcome');
      "
    >
      <i class="fas fa-home"></i>
    </button>

    <img
      class="auth-logo"
      src="/logo.png"
      alt=""
      @click="$router.push('/home')"
    />

    <section class="auth-card">
      <h3 class="auth-title">{{ $t("auth.register") }}</h3>
      <div class="error" v-if="error">
        {{ $t("auth.fail_message") }}
      </div>

      <form role="form">
        <label>{{ $t("auth.phone") }}</label>
        <input
          class="form-control"
          type="tel"
          inputmode="numeric"
          autocomplete="tel"
          v-model="phone"
          @keyup.enter="focusOnNameInputBox"
        />
        <small class="error-text">{{ errors.phone }}</small>

        <label>{{ $t("auth.username") }}</label>
        <input
          class="form-control"
          type="text"
          ref="name"
          v-model="name"
          @keyup.enter="focusOnPasswordInputBox"
        />
        <small class="error-text">{{ errors.name }}</small>

        <label>{{ $t("auth.password") }}</label>
        <div class="password-wrap">
          <input
            class="form-control"
            type="password"
            ref="password"
            v-model="password"
            @keyup.enter="focusOnConfirmInputBox"
          />
          <i
            class="far fa-eye showable-password"
            v-if="isShow"
            @click="
              $playSound();
              showablePassword();
            "
          ></i>
          <i
            class="fas fa-eye-slash showable-password"
            v-if="!isShow"
            @click="
              $playSound();
              showablePassword();
            "
          ></i>
        </div>
        <small class="error-text">{{ errors.password }}</small>

        <label>{{ $t("setting.confirm_password") }}</label>
        <div class="password-wrap">
          <input
            class="form-control"
            type="password"
            ref="confirmPassword"
            v-model="confirmPassword"
            @keyup.enter="loginWithPhone"
          />
          <i
            class="far fa-eye showable-password"
            v-if="isShowConfirm"
            @click="
              $playSound();
              showableConfirmPassword();
            "
          ></i>
          <i
            class="fas fa-eye-slash showable-password"
            v-if="!isShowConfirm"
            @click="
              $playSound();
              showableConfirmPassword();
            "
          ></i>
        </div>
        <small class="error-text">{{ errors.confirmPassword }}</small>

        <button
          type="button"
          class="submit-btn"
          @click="
            $playSound();
            loginWithPhone();
          "
        >
          <span v-if="!isSignin">{{ $t("auth.register") }}</span>
          <Loading color="#1a1408" v-if="isSignin" size="22" />
        </button>
      </form>

      <button
        type="button"
        class="switch-link"
        @click="$router.push('/auth/login')"
      >
        {{ $t("auth.go_login") }}
      </button>
    </section>

    <div class="row mt-3">
      <div class="col-4">
        <div
          class="modal fade"
          id="forgetPassword"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modal-form"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal- modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body p-5">
                <b>
                  Please direct contact to customer service -
                  <span class="text-danger">09756477723</span>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      confirmPassword: null,
      phone: null,
      error: false,
      errors: {},
      isSignin: false,
      isShow: false,
      isShowConfirm: false,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    showablePassword() {
      if (this.isShow) {
        this.$refs.password.type = "password";
      } else {
        this.$refs.password.type = "text";
      }
      this.isShow = !this.isShow;
    },
    showableConfirmPassword() {
      if (this.isShowConfirm) {
        this.$refs.confirmPassword.type = "password";
      } else {
        this.$refs.confirmPassword.type = "text";
      }
      this.isShowConfirm = !this.isShowConfirm;
    },
    focusOnNameInputBox() {
      this.$refs.name.focus();
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    focusOnConfirmInputBox() {
      this.$refs.confirmPassword.focus();
    },
    /**
     * register with phone, name, password
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.phone) {
        this.errors.phone = this.$t("auth.require_phone");
        this.isSignin = false;
        return false;
      }
      if (!this.name) {
        this.errors.name = this.$t("auth.require_username");
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t("auth.require_password");
        this.isSignin = false;
        return false;
      }
      if (!this.confirmPassword) {
        this.errors.confirmPassword = this.$t("auth.require_confirm_password");
        this.isSignin = false;
        return false;
      }
      if (this.password !== this.confirmPassword) {
        this.errors.confirmPassword = this.$t("auth.password_mismatch");
        this.isSignin = false;
        return false;
      }
      try {
        if (this.phone === "testuser") {
          window.open("https://about.myanmarsoccer.xyz", "_self");
        } else {
          const res = await this.axios.post(
            "/auth/register",
            {
              phone: this.phone,
              user_name: this.name,
              password: this.password,
              confirmPassword: this.confirmPassword,
              roles: "normal",
              fcm: localStorage.getItem("fcm"),
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          localStorage.setItem("phone", this.phone);
          localStorage.setItem("username", this.name);
          localStorage.setItem("password", this.password);
          localStorage.setItem("token", res.data.token);

          const currentTime = new Date();
          localStorage.setItem(
            "tokenExpire",
            new Date(currentTime.getTime() + 60 * 60 * 1000)
          );
          await this.fetchUser();
          this.$router.push("/home");
          Toast.success(
            this.$store.state.language === "en" ? "Success!" : "Success!"
          );
        }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === "normal")
      this.$router.push("/home");
    const phone = localStorage.getItem("phone");
    const password = localStorage.getItem("password");
    if (phone && password) {
      this.phone = phone;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  padding: 28px 16px 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.welcome-back-btn {
  position: fixed;
  top: 16px;
  right: 16px;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: #1c1c1c;
  color: #f7d56a;
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}
.welcome-back-btn i {
  font-size: 1rem;
}
.auth-logo {
  height: 88px;
  margin: 12px 0 18px;
  cursor: pointer;
  object-fit: contain;
}
.auth-card {
  width: 100%;
  max-width: 420px;
  background: #1c1c1c;
  border-radius: 16px;
  padding: 18px 16px 16px;
}
.auth-title {
  margin: 0 0 14px;
  color: #f0e6c8;
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
}
.auth-card label {
  display: block;
  margin-bottom: 6px;
  color: #f0e6c8;
  font-weight: 600;
}
.auth-card .form-control {
  height: 2.7rem;
  border-radius: 10px;
  margin-bottom: 4px;
}
.password-wrap {
  position: relative;
}
.showable-password {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #c9c3b8;
  cursor: pointer;
  z-index: 2;
}
.error-text {
  display: block;
  min-height: 1em;
  margin-bottom: 10px;
  color: #ff8a6a;
  font-size: 0.78rem;
}
.error {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #2a1612;
  color: #ff8a6a;
  text-align: center;
  font-size: 0.85rem;
}
.submit-btn {
  width: 100%;
  height: 2.7rem;
  margin-top: 8px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
  cursor: pointer;
}
.switch-link {
  display: block;
  width: 100%;
  margin-top: 12px;
  border: 0;
  background: transparent;
  color: #d8c48a;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
</style>
